import { html } from 'lit-element'
import { ShellElement } from '../../common/shell-element'
import type { I18NEvents } from '../../services/i18n'
import { setDocumentLocale, getCurrentLocale, I18NNamespace } from '../../services/i18n'
import { getEventBus } from '../../services/namespaces/event-bus'
import { isMacContainer } from '../../services/container/helpers'
import { getTopbarService } from '../../services/topbar/facade'
/**
 * Element that allows to interact with the shell instance in a document context
 */

export class GoToShellController extends ShellElement {
  static readonly tagName = 'goto-shell-controller'
  private initialized = false

  /**
   * initialize the controller with shell.  Shell API must be available prior calling this
   */
  public initializeController() {
    this.initialized = true
    if (this.isConnected) {
      this.init()
    }
  }

  private init() {
    this.updateLocale()
    this.subscribeToLocaleChange()
    if (isMacContainer()) {
      this.subscribeToWindowFocusChange()
    }
  }

  connectedCallback() {
    super.connectedCallback()
    if (this.initialized) {
      this.init()
    }
  }

  render() {
    return html`<slot></slot>`
  }

  private updateLocale = () => {
    setDocumentLocale(getCurrentLocale(), document)
  }

  private subscribeToWindowFocusChange() {
    window.addEventListener('focus', this.handleFocusEvent)
    window.addEventListener('blur', this.handleBlurEvent)
    this.unsubscribeFunctions.push(() => {
      window.removeEventListener('focus', this.handleFocusEvent)
      window.removeEventListener('blur', this.handleBlurEvent)
    })
  }
  private handleFocusEvent = () => {
    document.body.classList.remove('application-unfocused')
  }

  private handleBlurEvent = () => {
    if (getTopbarService().isVisible()) {
      document.body.classList.add('application-unfocused')
    }
  }

  private subscribeToLocaleChange() {
    const { localeChanged } = getEventBus().subscribeTo<typeof I18NNamespace, typeof I18NEvents>(I18NNamespace)
    localeChanged.on(this.updateLocale)
    this.unsubscribeFunctions.push(() => {
      localeChanged.removeListener(this.updateLocale)
    })
  }
}

declare global {
  interface HTMLElementTagNameMap {
    readonly [GoToShellController.tagName]: GoToShellController
  }
}
